class PlannerLiveSessionManager {

    constructor(app) {
        this.app = app;
        this.updateStatus = ''
        this.notificationBar = $('.notification-bar');
        this.appSharingMode = $('.app-sharing-mode');
        this.appRequestedMode = $('.app-requested-mode');
        this.lastScreenshot = null;
        this.actioning = false;
        $('.app-end-live-share').click(function(e){
            e.preventDefault();
            this.updateStatus='N';
            this.update(true);
        }.bind(this));
        $('.app-allow-live-share').click(function(e){
            e.preventDefault();
            this.updateStatus='L';
            this.update(true);
        }.bind(this));
        $('.app-dismiss-live-share').click(function(e){
            e.preventDefault();
            this.updateStatus='D';
            this.update(true);
        }.bind(this));
        setTimeout(this.update.bind(this), 5000);
        setTimeout(this.screencast.bind(this), 2000);
    }

    update(action) {
        action = falseIfUndefined(action);
        if(action) {
            this.actioning = true;
        } else {
            if(this.actioning) {
                setTimeout(this.update.bind(this), this.updateStatus === 'L' ? 1000 : 5000);
                return;
            }
        }
        let profile = this.app.yourProfile;
        if(!profile.isSharedPlan() &&
            profile.getYourDetails().isComplete() &&
            profile.getCurrentSection() > 0) {

            this.app.api.registerForLiveSession(
                this.app.plannerType,
                profile.getGuid(),
                {
                    'email': profile.getYourDetails().getEmail(),
                    'firstName': profile.getYourDetails().getFirstName(),
                    'lastName': profile.getYourDetails().getLastName(),
                    'course': profile.getCourseName(),
                    'status': this.updateStatus,
                    'screen': this.lastScreenshot,
                },
                function(results) {
                    this.updateState(results.status);
                    this.actioning = false;
                }.bind(this))

        }
        if(!action) {
            setTimeout(this.update.bind(this), this.updateStatus === 'L' ? 1000 : 5000);
        }
    }

    updateState(status) {
        if(status === 'Q' || status === 'L') {

            this.appRequestedMode.showIf(status === 'Q');
            this.appSharingMode.showIf(status === 'L');
            this.notificationBar.removeClass('hidden').addClass('show');
            $('body').addClass('live-sharing-banner-on');

        } else {
            this.notificationBar.addClass('hidden').removeClass('show');
            $('body').removeClass('live-sharing-banner-on');
        }
        this.updateStatus = status;
    }

    screencast() {
        if(this.updateStatus === 'L') {
            let element = $('body');
            html2canvas(element[0], {
                allowTaint: true,
                scale: 1,
                scrollY: -window.scrollY,
            }).then(function (canvas) {
                let scrBase64 = canvas.toDataURL('image/png');
                scrBase64 = scrBase64.split(',')[1];
                this.lastScreenshot = scrBase64;
            }.bind(this));
        } else {
            this.lastScreenshot = null;
        }

        setTimeout(this.screencast.bind(this), 1000);
    }
}
